import { init, last } from 'ramda'

const bp = { sm: 650, md: 850, lg: 1400 }

export const mediaQuery = (bpName, styles) => {
  if (!bpName) return ''
  let name = bpName
  if (name.length > 2) {
    name = init(name)
  }

  // TODO: Consider direction
  const rules = `@media (max-width: ${bp[name]}px)`
  if (!styles) return rules
  return `${rules} {${styles}}`
}

export default bp
